import { useState, useEffect, useCallback, useMemo } from "react";

export default function useSelectedChannels({
  savedLocation,
  savedLocationLoading,
  channels,
  channelsAreLoading,
  initialState,
}) {
  const [selectedChannels, setSelectedChannels] = useState(
    initialState.channels ? initialState.channels.split(",") : []
  );
  const [channelsOnLoad] = useState(initialState.channels ? initialState.channels.split(",") : []);

  const areAllChannelsSelected = useMemo(() => selectedChannels.length === channels?.length, [
    selectedChannels,
    channels,
  ]);
  const selectOrDeselectAll = useCallback(() => {
    if (areAllChannelsSelected) {
      setSelectedChannels([]);
    } else {
      setSelectedChannels(channels?.map(c => c.id));
    }
  }, [areAllChannelsSelected, channels]);

  const toggleChannel = useCallback(
    channelId => {
      const isSelected = selectedChannels.includes(channelId);
      // remove the channel frm the list
      if (isSelected) {
        setSelectedChannels(selectedChannels.filter(channel => channel !== channelId));
      } else {
        setSelectedChannels([...selectedChannels, channelId]);
      }
    },
    [selectedChannels]
  );

  useEffect(() => {
    if (savedLocationLoading || channelsAreLoading) {
      return;
    }
    const r = channels
      .map(c => c.id)
      .filter(c => !channelsOnLoad.length || channelsOnLoad.includes(c.id));
    setSelectedChannels(savedLocation ? savedLocation.channels : r);
  }, [savedLocation, savedLocationLoading, channels, channelsAreLoading, channelsOnLoad]);

  return [toggleChannel, selectedChannels, selectOrDeselectAll, areAllChannelsSelected];
}
